// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__1TV0s","disabled":"FileBtn_disabled__akoG5","warn":"FileBtn_warn___pETz","fade":"FileBtn_fade__1XF50"};